var _path, _path2, _circle, _circle2, _circle3, _rect, _circle4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g, _circle5, _rect13, _path3, _path4, _path5, _g2, _path6, _rect14, _rect15, _rect16, _rect17, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 260,
    viewBox: "0 0 562 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.484 8.35549C158.484 3.93721 162.066 0.355469 166.484 0.355469H514.66C519.079 0.355469 522.66 3.93719 522.66 8.35547V259.999H158.484V8.35549Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.484 8.35547C158.484 3.93719 162.066 0.355469 166.484 0.355469H514.66C519.079 0.355469 522.66 3.93719 522.66 8.35547V31.8275H158.484V8.35547Z",
    fill: "#6D6D6D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180.401,
    cy: 15.5297,
    r: 6.182,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.137,
    cy: 15.5297,
    r: 6.182,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.873,
    cy: 15.5297,
    r: 6.182,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 193.326,
    y: 54.3066,
    width: 212.436,
    height: 17.984,
    rx: 5,
    fill: "#EAEAEA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.897,
    cy: 62.7365,
    r: 15.174,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 420.377,
    y: 54.3066,
    width: 93.292,
    height: 179.84,
    rx: 4,
    fill: "#EAEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 429.367,
    y: 72.291,
    width: 132.632,
    height: 76.432,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 450.725,
    y: 88.0273,
    width: 49.456,
    height: 8.992,
    rx: 4.496,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 450.725,
    y: 101.516,
    width: 89.92,
    height: 10.116,
    rx: 5.058,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 186.584,
    y: 172.328,
    width: 110.152,
    height: 11.24,
    rx: 5.62,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 186.584,
    y: 192.559,
    width: 110.152,
    height: 12.364,
    rx: 6.182,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 186.584,
    y: 212.791,
    width: 46.084,
    height: 11.24,
    rx: 5.62,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 450.725,
    y: 125.119,
    width: 91.044,
    height: 8.992,
    rx: 4.496,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 174.221,
    y: 83.5312,
    width: 231.544,
    height: 150.616,
    rx: 4,
    fill: "#EAEAEA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 311.348,
    y: 119.5,
    width: 79.804,
    height: 104.532,
    rx: 4,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1066_856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 119,
    width: 81,
    height: 106
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 311.348,
    y: 119.5,
    width: 79.804,
    height: 104.532,
    rx: 4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1066_856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.058 185.237C330.239 183.403 332.921 183.403 334.103 185.237L356.831 220.532C358.117 222.528 356.684 225.156 354.309 225.156H308.852C306.477 225.156 305.044 222.528 306.329 220.532L329.058 185.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.945 175.024C368.143 173.612 370.322 173.612 371.52 175.024L412.251 223.025C413.904 224.974 412.519 227.966 409.963 227.966H328.502C325.946 227.966 324.561 224.974 326.215 223.025L366.945 175.024Z",
    fill: "white"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.829,
    cy: 157.716,
    r: 12.364,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 359.68,
    height: 55.076,
    rx: 9,
    fill: "#0A1931"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 107.143C0 102.172 4.02944 98.1426 9 98.1426H55.076V153.219H8.99999C4.02943 153.219 0 149.189 0 144.219V107.143Z",
    fill: "#185ADB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2163 130.894C38.2163 135.146 28.1659 138.607 15.7363 138.607V127.094H26.0781L22.4366 135.371L34.0408 126.379C36.6626 127.658 38.2163 129.201 38.2163 130.894Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2163 111.631V123.144H27.8746L31.516 114.866L19.9604 123.858C17.29 122.579 15.7849 121.037 15.7849 119.381C15.7363 115.092 25.8353 111.631 38.2163 111.631Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1066_856)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 359.68,
    cy: 125.12,
    r: 12.364,
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M362.49 119.5L357.432 124.558L362.49 129.616",
    stroke: "#185ADB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 179.84,
    y: 103.764,
    width: 44.96,
    height: 23.604,
    rx: 4,
    fill: "#19273C"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 167.477,
    y: 131.863,
    width: 69.688,
    height: 13.488,
    rx: 6,
    fill: "#19273C"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 254.023,
    y: 131.863,
    width: 69.688,
    height: 13.488,
    rx: 6,
    fill: "#19273C"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 266.389,
    y: 103.764,
    width: 44.96,
    height: 23.604,
    rx: 4,
    fill: "#19273C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.531 109L91.043 119.116H94.415V132.604H101.159V125.86H107.903V132.604H114.647V119.015L118.019 119.116L104.531 109Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8223 138.584V138.854C94.8223 139.174 94.7822 139.461 94.7021 139.715C94.6221 139.969 94.5068 140.185 94.3564 140.362C94.2061 140.54 94.0254 140.676 93.8145 140.77C93.6055 140.863 93.3711 140.91 93.1113 140.91C92.8594 140.91 92.6279 140.863 92.417 140.77C92.208 140.676 92.0264 140.54 91.8721 140.362C91.7197 140.185 91.6016 139.969 91.5176 139.715C91.4336 139.461 91.3916 139.174 91.3916 138.854V138.584C91.3916 138.264 91.4326 137.978 91.5146 137.726C91.5986 137.472 91.7168 137.256 91.8691 137.078C92.0215 136.898 92.2021 136.762 92.4111 136.668C92.6221 136.574 92.8535 136.527 93.1055 136.527C93.3652 136.527 93.5996 136.574 93.8086 136.668C94.0195 136.762 94.2002 136.898 94.3506 137.078C94.5029 137.256 94.6191 137.472 94.6992 137.726C94.7812 137.978 94.8223 138.264 94.8223 138.584ZM94.2627 138.854V138.578C94.2627 138.324 94.2363 138.1 94.1836 137.904C94.1328 137.709 94.0576 137.545 93.958 137.412C93.8584 137.279 93.7363 137.179 93.5918 137.11C93.4492 137.042 93.2871 137.008 93.1055 137.008C92.9297 137.008 92.7705 137.042 92.6279 137.11C92.4873 137.179 92.3662 137.279 92.2646 137.412C92.165 137.545 92.0879 137.709 92.0332 137.904C91.9785 138.1 91.9512 138.324 91.9512 138.578V138.854C91.9512 139.109 91.9785 139.336 92.0332 139.533C92.0879 139.729 92.166 139.894 92.2676 140.028C92.3711 140.161 92.4932 140.262 92.6338 140.33C92.7764 140.398 92.9355 140.433 93.1113 140.433C93.2949 140.433 93.458 140.398 93.6006 140.33C93.7432 140.262 93.8633 140.161 93.9609 140.028C94.0605 139.894 94.1357 139.729 94.1865 139.533C94.2373 139.336 94.2627 139.109 94.2627 138.854ZM96.4008 140.362L97.268 137.682H97.8217L96.682 140.852H96.3187L96.4008 140.362ZM95.6771 137.682L96.5707 140.377L96.6322 140.852H96.2689L95.1205 137.682H95.6771ZM99.4676 140.91C99.2469 140.91 99.0467 140.873 98.867 140.799C98.6893 140.723 98.5359 140.616 98.407 140.479C98.2801 140.343 98.1824 140.181 98.1141 139.993C98.0457 139.806 98.0115 139.601 98.0115 139.378V139.255C98.0115 138.997 98.0496 138.768 98.1258 138.566C98.202 138.363 98.3055 138.191 98.4363 138.051C98.5672 137.91 98.7156 137.804 98.8816 137.731C99.0477 137.659 99.2195 137.623 99.3973 137.623C99.6238 137.623 99.8191 137.662 99.9832 137.74C100.149 137.818 100.285 137.928 100.39 138.068C100.496 138.207 100.574 138.371 100.625 138.561C100.676 138.748 100.701 138.953 100.701 139.176V139.419H98.3338V138.977H100.159V138.936C100.151 138.795 100.122 138.658 100.071 138.525C100.022 138.393 99.9441 138.283 99.8367 138.197C99.7293 138.111 99.5828 138.068 99.3973 138.068C99.2742 138.068 99.1609 138.095 99.0574 138.147C98.9539 138.198 98.865 138.274 98.7908 138.376C98.7166 138.478 98.659 138.602 98.618 138.748C98.577 138.895 98.5564 139.063 98.5564 139.255V139.378C98.5564 139.528 98.577 139.67 98.618 139.803C98.6609 139.934 98.7225 140.049 98.8025 140.148C98.8846 140.248 98.9832 140.326 99.0984 140.383C99.2156 140.439 99.3484 140.468 99.4969 140.468C99.6883 140.468 99.8504 140.429 99.9832 140.351C100.116 140.272 100.232 140.168 100.332 140.037L100.66 140.298C100.592 140.401 100.505 140.5 100.399 140.594C100.294 140.688 100.164 140.764 100.01 140.822C99.8572 140.881 99.6766 140.91 99.4676 140.91ZM101.726 138.18V140.852H101.184V137.682H101.711L101.726 138.18ZM102.716 137.664L102.713 138.168C102.668 138.158 102.625 138.152 102.584 138.15C102.545 138.146 102.5 138.145 102.449 138.145C102.324 138.145 102.214 138.164 102.118 138.203C102.023 138.242 101.942 138.297 101.875 138.367C101.809 138.438 101.756 138.521 101.717 138.619C101.68 138.715 101.655 138.82 101.644 138.936L101.491 139.023C101.491 138.832 101.51 138.652 101.547 138.484C101.586 138.316 101.646 138.168 101.726 138.039C101.806 137.908 101.907 137.807 102.03 137.734C102.155 137.66 102.304 137.623 102.476 137.623C102.515 137.623 102.56 137.628 102.611 137.638C102.661 137.646 102.696 137.654 102.716 137.664ZM104.084 140.362L104.951 137.682H105.504L104.365 140.852H104.002L104.084 140.362ZM103.36 137.682L104.254 140.377L104.315 140.852H103.952L102.803 137.682H103.36ZM106.465 137.682V140.852H105.92V137.682H106.465ZM105.879 136.841C105.879 136.753 105.905 136.679 105.958 136.618C106.013 136.558 106.093 136.527 106.198 136.527C106.302 136.527 106.381 136.558 106.436 136.618C106.492 136.679 106.521 136.753 106.521 136.841C106.521 136.925 106.492 136.997 106.436 137.058C106.381 137.116 106.302 137.146 106.198 137.146C106.093 137.146 106.013 137.116 105.958 137.058C105.905 136.997 105.879 136.925 105.879 136.841ZM108.5 140.91C108.28 140.91 108.079 140.873 107.9 140.799C107.722 140.723 107.569 140.616 107.44 140.479C107.313 140.343 107.215 140.181 107.147 139.993C107.079 139.806 107.044 139.601 107.044 139.378V139.255C107.044 138.997 107.082 138.768 107.159 138.566C107.235 138.363 107.338 138.191 107.469 138.051C107.6 137.91 107.748 137.804 107.914 137.731C108.08 137.659 108.252 137.623 108.43 137.623C108.657 137.623 108.852 137.662 109.016 137.74C109.182 137.818 109.318 137.928 109.423 138.068C109.529 138.207 109.607 138.371 109.658 138.561C109.708 138.748 109.734 138.953 109.734 139.176V139.419H107.367V138.977H109.192V138.936C109.184 138.795 109.155 138.658 109.104 138.525C109.055 138.393 108.977 138.283 108.87 138.197C108.762 138.111 108.616 138.068 108.43 138.068C108.307 138.068 108.194 138.095 108.09 138.147C107.987 138.198 107.898 138.274 107.824 138.376C107.749 138.478 107.692 138.602 107.651 138.748C107.61 138.895 107.589 139.063 107.589 139.255V139.378C107.589 139.528 107.61 139.67 107.651 139.803C107.694 139.934 107.755 140.049 107.835 140.148C107.917 140.248 108.016 140.326 108.131 140.383C108.248 140.439 108.381 140.468 108.53 140.468C108.721 140.468 108.883 140.429 109.016 140.351C109.149 140.272 109.265 140.168 109.365 140.037L109.693 140.298C109.624 140.401 109.538 140.5 109.432 140.594C109.327 140.688 109.197 140.764 109.042 140.822C108.89 140.881 108.709 140.91 108.5 140.91ZM111.019 140.289L111.834 137.682H112.191L112.121 138.2L111.292 140.852H110.943L111.019 140.289ZM110.471 137.682L111.166 140.318L111.216 140.852H110.849L109.929 137.682H110.471ZM112.971 140.298L113.633 137.682H114.172L113.252 140.852H112.888L112.971 140.298ZM112.27 137.682L113.067 140.245L113.158 140.852H112.812L111.96 138.194L111.889 137.682H112.27Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1066_856",
    x: 345.316,
    y: 112.756,
    width: 28.7285,
    height: 28.7285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1066_856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1066_856",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDetails);
export default __webpack_public_path__ + "static/media/productDetails.61154e7a262c838ef8758c28ad807cee.svg";
export { ForwardRef as ReactComponent };